export default defineNuxtPlugin(async (nuxtApp) => {
    const airline = useAirlinesStore();
    const train = useTrainStore();
    const pelni = usePelniStore();
    const passenger = usePassengersStore();
    const user = useUserStore();

    if (process.client) {
        const domesticAirports = localStorage.getItem('domesticAirports');
        const internationalAirports = localStorage.getItem('internationalAirports');
        const stations = localStorage.getItem('stations');
        const harbours = localStorage.getItem('harbours');
        // const passengers = localStorage.getItem('passengers');
        const airlinesCode = localStorage.getItem('airlines_code');
        const contact = localStorage.getItem('addreses');
        const deviceId = localStorage.getItem('deviceId');
    
        const saveToLocalStorage = (key: string, data: any) => {
            localStorage.setItem(key, JSON.stringify(data));
        };
    
        if (!domesticAirports) {
            const domAirports = await airline.getDomesticAirport();
            saveToLocalStorage('domesticAirports', domAirports);
        }
    
        if (!internationalAirports) {
            const intAirports = await airline.getInternationalAirport();
            saveToLocalStorage('internationalAirports', intAirports);
        }
    
        if (!stations) {
            const stationsData = await train.getStations();
            saveToLocalStorage('stations', stationsData);
        }
    
        if (!harbours) {
            const harboursData = await pelni.getPelabuhan();
            saveToLocalStorage('harbours', harboursData);
        }
    
        // if (!passengers) {
        //     const passengersData = await passenger.getPassengers(); // Assuming you have this function in passenger store
        //     saveToLocalStorage('passengers', passengersData);
        //     console.log('Passengers fetched and stored');
        // }
    
        if (!airlinesCode) {
            const airlinesCodeData = await airline.getAirlinesCode();
            saveToLocalStorage('airlines_code', airlinesCodeData);
        }
    
        if (!contact) {
            const contactData = await user.getInfoContact();
            saveToLocalStorage('addreses', contactData);
        }
    
        // if (!deviceId) {
        //     const currentDevice = user.deviceId();
        //     saveToLocalStorage('deviceId', currentDevice);
        //     console.log('Device ID fetched and stored');
        // }
    }
})
